module.exports = "https://static.wmbcdn.com/uniweb/images/38a96eaf6023599270f20e64a1bdc3ec.svg";